import { AnswerAssessmentVerdict } from "../../types";
import { getVerdictClassName, getVerdictLabel } from "./verdictHelpers";

/**
 * Props for the verdict badge pill.
 */
interface VerdictBadgeProps {
  /** Assessment verdict shown as a title-cased pill. */
  verdict: AnswerAssessmentVerdict;
}

/**
 * Title-cased verdict badge (Satisfies / Violates / Insufficient).
 *
 * @param props.verdict - Assessment verdict
 */
const VerdictBadge = (props: VerdictBadgeProps) => (
  <span
    className={`mt-0.5 shrink-0 rounded px-2.5 py-1 text-x-tiny font-semibold ${getVerdictClassName(
      props.verdict,
    )}`}
  >
    {getVerdictLabel(props.verdict)}
  </span>
);

export default VerdictBadge;
